module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAXVBMVEVHcEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABsMPPGAAAAHnRSTlMAGdD0/lj38xgXcobO8leFcITRgxZx8XRac1nP+Bqpe8UlAAAAqklEQVRIx+2WyQ6DMAxEIRASwl6ge/P/n1lHlbL04PjCBXluI83DTpAYiuJ80p2oLKJKTG1KPNH8T0rGxL22BNURo5UlSYXdOrDNrLGzlnsDocX7C7g5d0EGQsI7t5fOIa3bzDu3Z/49JClGGGGEEUYOQkif8Q+ErklZmBxyg9DLu8lVkinRSnq8IbSG6iAW37CFZ0havY7xXEmYM4x/tbb0KKX6dTvhH9IXGdZBcYyEciMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-unchecked.png
// module id = 1572
// module chunks = 0